/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Form/Fields/AssignedDoctor/Loading",
  onChange
  
}) {
let providersValueData = fromData.useDataValue({ viewPath,
context: 'providers',
})
let newPatientProviderIdValueData = fromData.useDataValue({ viewPath,
context: 'new_patient',
path: 'provider_id',
})
let newPatientProviderIdChangeData = fromData.useDataChange({ viewPath,
context: 'new_patient',
path: 'provider_id',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 size="medium"
 data="providers"
 from={providersValueData}
 data="new_patient.provider_id"
 value={newPatientProviderIdValueData}
 onChange={newPatientProviderIdChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Assigned Doctor"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}